import { createContext, useEffect, useState } from "react";
import { state_details_api } from "../api/api";

export const MyContext = createContext();

export const AppContext = ({ children }) => {
    const [adminData, setAdminData] = useState(JSON.parse(localStorage.getItem("admin_data")) || []);
    const [stateList, setStateList] = useState();
    const [loader, setLoader] = useState(false);
    const [userType, setUserType] = useState('');



    const getUserType = () => {
        const data = JSON.parse(localStorage.getItem("admin_data"));
        if (data != null) {
            setUserType(data.user_type)
        }
    }

    
    useEffect(() => {
        getUserType();
    }, [])

    

    const state_details_api_call = async () => {
        try {
            const res = await state_details_api();
            if (res.status === 200) {
                setStateList(res.data.data);
            }
        } catch (error) {
            console.error("state api error", error);
        }
    };


    const dateFormate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-GB', { year: 'numeric', month: 'short', day: '2-digit' });
    }


    return (
        <MyContext.Provider value={{
            state_details_api_call,
            setAdminData,
            adminData,
            setStateList,
            stateList,
            dateFormate,
            setLoader,
            loader,
            userType, setUserType, getUserType
        }}
        >
            {children}
        </MyContext.Provider>
    )
}